import { Modal as ModalBase } from "@evidenceprime/react-components";
import PropTypes from "prop-types";
import React, { FC, ReactNode, useRef } from "react";
import { useHandleClickOutside } from "../../lib/custom_hooks";

interface IModal {
  isOpen: boolean;
  children: ReactNode;
  onClose: () => void;
  closeButton?: boolean;
  modalSize?: string;
  parentSelector?: () => void;
}

const Modal: FC<IModal> = ({
  isOpen,
  children,
  onClose,
  closeButton,
  modalSize,
  parentSelector = () => document.body,
}) => {
  const contentRef = useRef(null);

  useHandleClickOutside(contentRef, onClose);

  return (
    <ModalBase isOpen={isOpen} modalSize={modalSize} parentSelector={parentSelector}>
      <div className="modal-content" ref={contentRef}>
        {closeButton && onClose && (
          <div>
            <span className="close-modal" onClick={onClose} />
          </div>
        )}
        {children}
      </div>
    </ModalBase>
  );
};

Modal.propTypes = {
  closeButton: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  modalSize: PropTypes.string,
};

Modal.defaultProps = {
  closeButton: false,
  modalSize: "medium",
};

export default Modal;
